"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMaskField = exports.VPublicMask = void 0;
var mobx_react_1 = require("mobx-react");
var React = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
var mobx_1 = require("mobx");
var textMaskAddons_1 = require("text-mask-addons/dist/textMaskAddons");
exports.VPublicMask = {
    emailMask: textMaskAddons_1.emailMask,
    createNumberMask: textMaskAddons_1.createNumberMask
};
var VMaskField = (function (_super) {
    __extends(VMaskField, _super);
    function VMaskField(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e) {
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange(e.target.value);
            }
            if (_this.props.onChange) {
                _this.props.onChange(e.target.value);
            }
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.inputRef = React.createRef();
        return _this;
    }
    VMaskField.prototype.render = function () {
        var _a = this.props, label = _a.label, fieldState = _a.fieldState, disabled = _a.disabled, inline = _a.inline, id = _a.id, className = _a.className, layer = _a.layer, fill = _a.fill, noLabel = _a.noLabel, required = _a.required, validators = _a.validators, margin = _a.margin, tipLabel = _a.tipLabel, displayRequired = _a.displayRequired, autoComplete = _a.autoComplete, width = _a.width;
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
        return (React.createElement(style_1.StyledInput, { className: className, disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, layer: layer, fill: fill, noLabel: noLabel, margin: margin },
            React.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState },
                tipLabel && React.createElement("span", { className: 'tipLabel' }, tipLabel),
                React.createElement(style_1.StyledMaskInput, { name: id, mask: this.props.mask, autoComplete: autoComplete ? autoComplete : 'off', guide: this.props.guide, keepCharPositions: this.props.keepCharPositions, placeholderChar: this.props.placeholderChar, pipe: this.props.pipe, disabled: disabled, showMask: this.props.showMask, onChange: this.onChange, onKeyDown: this.props.onKeyDown, onKeyPress: this.props.onKeyPress, onBlur: this.props.onBlur, onFocus: this.props.onFocus, value: this.valueField, style: {
                        paddingRight: 10,
                        width: width ? width : '100%'
                    }, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE }))));
    };
    Object.defineProperty(VMaskField.prototype, "valueField", {
        get: function () {
            if (this.props.fieldState) {
                return this.props.fieldState.value || '';
            }
            if (this.props.value) {
                return this.props.value;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], VMaskField.prototype, "valueField", null);
    VMaskField = __decorate([
        mobx_react_1.observer
    ], VMaskField);
    return VMaskField;
}(React.Component));
exports.VMaskField = VMaskField;
